import { ReactNode } from 'react';

import * as Styled from './footer.style';
import { FooterSubjectsPlaceholder } from 'approot/shared/layout/footer/footer-subjects-placeholder';
import { NUMBER_OF_SUBJECTS_AU } from 'global/constants';

type Subject = {
  name: string;
  label: string;
};

export const FooterSubjectLinks = ({
  render,
  loading,
  subjects,
  stimulusLinks,
}: {
  render: (subject: Subject) => ReactNode;
  subjects: Subject[] | undefined;
  loading: boolean;
  stimulusLinks: ReactNode;
}) => {
  const numberOfSubjects = NUMBER_OF_SUBJECTS_AU + 2;
  // Include Stimulus Library and Scope & Sequence links

  return loading ? (
    <Styled.FooterLessonsGroup>
      <FooterSubjectsPlaceholder numberOfSubjects={numberOfSubjects} />
    </Styled.FooterLessonsGroup>
  ) : (
    <Styled.FooterLinksFadeIn>
      <Styled.FooterLessonsGroup>
        {subjects?.map(subject => render(subject))}
        {stimulusLinks}
      </Styled.FooterLessonsGroup>
    </Styled.FooterLinksFadeIn>
  );
};
